import RequestService from '../request-service';

export default class BookBetslipRequestService extends RequestService {
  constructor(betslipStore) {
    super();

    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.BookBetslip;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'post';
    /**
     * Post parameters
     */
    this.postParams = {
      betSlip: JSON.stringify(betslipStore),
      eventList: Object.keys(betslipStore.matchItems),
      externalUserID: APP_SETTINGS.player.id || null,
    };
    this.headers = null;
  }
}
